module.exports = __webpack_public_path__ + "themes/non-default/vennProvidedLogo.1b791be1ed268b69a097b5013bd86a0e.png";